module.exports = __webpack_public_path__ + "38a0bb1100e0394d7f361736c892f80f.pdf";